<div class="op-page">
  <div class="op-card">
    <div class="op-bar"><span>Bistec Apex</span></div>

    <div class="op-body" *ngIf="loading">
      <p class="op-muted">Loading photos…</p>
    </div>

    <div class="op-body" *ngIf="!loading && notFound">
      <h1>Photos not found</h1>
      <p class="op-muted">This photo link is invalid or has expired.</p>
    </div>

    <div class="op-body" *ngIf="!loading && data">
      <h1>{{ data.eventName }}</h1>
      <p class="op-muted">{{ data.projectName }} · organized by {{ data.pmName }}</p>

      <div class="op-meta">
        <span><strong>Date:</strong> {{ data.plannedDate | date:'fullDate' }}</span>
        <span *ngIf="data.location"><strong>Venue:</strong> {{ data.location }}</span>
        <span><strong>Photos:</strong> {{ data.photos.length }}</span>
      </div>

      <div class="op-actions" *ngIf="data.photos.length">
        <p-button label="Download all (zip)" icon="pi pi-download"
                  [loading]="downloadingAll" (onClick)="downloadAll()" severity="primary" />
      </div>

      <div class="op-grid" *ngIf="data.photos.length; else noPhotos">
        <figure class="op-thumb" *ngFor="let p of data.photos">
          <a [href]="p.url" target="_blank" rel="noopener" [title]="p.fileName">
            <img [src]="p.url" [alt]="p.fileName" loading="lazy" />
          </a>
          <button type="button" class="op-dl" (click)="download(p)" title="Download">
            <i class="pi pi-download"></i>
          </button>
        </figure>
      </div>
      <ng-template #noPhotos>
        <p class="op-muted">No photos have been uploaded for this outing yet.</p>
      </ng-template>
    </div>

    <div class="op-foot"><p>Bistec Apex — Team Outings</p></div>
  </div>
</div>
